import Avatar from "boring-avatars";
import { type ReactNode } from "react";

/**
 * The one brand avatar used everywhere a person is shown — the sidebar logged-in pill (UserMenu),
 * the login page's floating quotes, and the account Profile card. It wraps `boring-avatars` with the
 * SAME vivid palette and the SAME ABSTRACT/COLORFUL variant set, choosing the variant
 * deterministically from the seed so one person always gets the same abstract icon across the app.
 * Decorative by default (aria-hidden); pass `title` for a hover label.
 */
const AVATAR_PALETTE = ["#1e4562", "#5f8aa5", "#7aa7c4", "#f0ab3d", "#e86a5c", "#8f6bd4", "#2bb5a0"];
const AVATAR_VARIANTS = ["marble", "bauhaus", "sunset", "abstract"] as const;
type AvatarVariant = (typeof AVATAR_VARIANTS)[number];

/** Deterministic variant from the seed, so the same person always gets the same abstract style. */
export function avatarVariantFor(seed: string): AvatarVariant {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  const idx = Math.abs(hash) % AVATAR_VARIANTS.length;
  return AVATAR_VARIANTS[idx] ?? "marble";
}

export function BrandAvatar(props: { seed: string; size?: number }): ReactNode {
  const seed = props.seed.trim().length > 0 ? props.seed.trim() : "operator";
  return (
    <Avatar
      name={seed}
      variant={avatarVariantFor(seed)}
      size={props.size ?? 32}
      colors={AVATAR_PALETTE}
    />
  );
}
